import { render, staticRenderFns } from "./MagzPlus.vue?vue&type=template&id=ed0b8e60&"
import script from "./MagzPlus.vue?vue&type=script&lang=js&"
export * from "./MagzPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports